module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ed-Fb-Ga.adef3e7f.png";